export const syncPageTargetingFromAdInfo = () => {
	const pubads = googletag.pubads();
	const adInfo = window.adInfo ?? {};

	for (const [key, value] of Object.entries(adInfo)) {
		if (value === undefined || value === null || value === '') {
			pubads.clearTargeting(key);
			continue;
		}

		const next = Array.isArray(value) ? value.map(String) : String(value);

		const prev = pubads.getTargeting(key);
		const prevFlat = prev.join('|');
		const nextFlat = Array.isArray(next) ? next.join('|') : next;

		if (prevFlat !== nextFlat) {
			pubads.setTargeting(key, next);
		}
	}
};

export const gptSetup = () => {
	if (window.globalAdConfig.disableInitialAdLoad) {
		googletag.pubads().disableInitialLoad();
	}

	if (window.globalAdConfig.gptEnableSingleRequest) {
		googletag.pubads().enableSingleRequest();
	}

	if (window.globalAdConfig.gptLazyLoading) {
		googletag.pubads().enableLazyLoad(window.globalAdConfig.gptLazyLoading);
	}

	googletag.enableServices();
	googletag.pubads().enableAsyncRendering();
	googletag.pubads().setCentering(true);
	googletag.pubads().setSafeFrameConfig({
		allowOverlayExpansion: false,
		allowPushExpansion: true,
		sandbox: true,
	});

	// Set page level targeting
	for (const [key, value] of Object.entries(window.adInfo)) {
		if (value) {
			googletag.pubads().setTargeting(key, value);
		}
	}

	if (typeof window.ketch === 'function') {
		window.ketch('once', 'consent', (consent) => {
			googletag.pubads().setTargeting('optout', consent?.purposes?.targeted_advertising ? 'false' : 'true');
		});
	} else {
		googletag.pubads().setTargeting('optout', 'false');

	}

	// Set ppid targeting
	const ppid = window.globalAdConfig.hashedEmail || window.globalAdConfig.ppid;
	if (ppid) {
		googletag.pubads().setPublisherProvidedId(ppid);
	}

	// Set location
	if (
		window.globalAdConfig.userData?.zipCodes?.length > 0 &&
		window.globalAdConfig.userData?.countryCode?.toLowerCase() === 'us'
	) {
		const zip = window.globalAdConfig.userData.zipCodes[0].primary;
		googletag.pubads().setLocation(`${zip},US`);
	}
};
